import axios from "axios";

const url = "/wp-json/messageflow/v1/settings";

// @ts-ignore
const { nonce } = window.adminUiAppContext || {};

export const axiosConn = axios.create({
	baseURL:
		process.env.NODE_ENV === "development"
			? process.env.REACT_APP_MOCK_SETTINGS
			: process.env.REACT_APP_PRODUCTION_URL,
	headers: {
		Accept: "application/json",
		"X-WP-Nonce": nonce,
	},
});

export const fetchAsSmsSettings = async () => {
	const response = await axiosConn.get(url);
	return response;
};

export const updateAsSmsSettings = async (
	values: Record<
		string,
		string | boolean | string[] | { [x: string]: boolean }[]
	>,
) => {
	const response = await axiosConn.post(url, values);

	return response;
};
